import { IntegrityMonitorEntityType } from '../../../../common/utils/types';
import {
  WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_FILE_FORM,
  WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_DIRECTORY_FORM,
  WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_REGISTRYKEY_FORM,
  WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_REGISTRYVALUE_FORM,
} from '../../../../../webcomponents.constants';

// add forms here after implementation
export function getIntegrityMonitorEntityTypes() {
  return [
    {
      label: 'File',
      value: IntegrityMonitorEntityType.FILE,
      implemented: true,
      formTag: WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_FILE_FORM,
    },
    {
      label: 'Directory',
      value: IntegrityMonitorEntityType.DIRECTORY,
      implemented: true,
      formTag: WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_DIRECTORY_FORM,
    },
    {
      label: 'Registry Key',
      value: IntegrityMonitorEntityType.REGISTRYKEY,
      implemented: true,
      formTag: WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_REGISTRYKEY_FORM,
    },
    {
      label: 'Registry Value',
      value: IntegrityMonitorEntityType.REGISTRYVALUE,
      implemented: true,
      formTag: WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_REGISTRYVALUE_FORM,
    },
    {
      label: 'Installed Software',
      value: IntegrityMonitorEntityType.SOFTWARE,
      implemented: false,
    },
    {
      label: 'Process',
      value: IntegrityMonitorEntityType.PROCESS,
      implemented: false,
    },
    {
      label: 'Port',
      value: IntegrityMonitorEntityType.PORT,
      implemented: false,
    },
    {
      label: 'Service',
      value: IntegrityMonitorEntityType.SERVICE,
      implemented: false,
    },
    {
      label: 'Users',
      value: IntegrityMonitorEntityType.USERS,
      implemented: false,
    },
    {
      label: 'Groups',
      value: IntegrityMonitorEntityType.GROUPS,
      implemented: false,
    },
    {
      label: 'Shares',
      value: IntegrityMonitorEntityType.SHARES,
      implemented: false,
    },
  ];
}
